<div class="tender-submit-quote">
  <p class="tender-submit-quote__intro">
    {{ 'tenders.submitQuoteIntro' | translate }}
  </p>

  <div class="tender-submit-quote__action">
    <div class="tender-submit-quote__cta">
      @if (isUserLoggedIn()) {
        <pwj-button
          variant="primary"
          size="large"
          icon="chevron-right"
          [rotateIconInRtl]="true"
          [iconReversePosition]="true"
          type="button"
          [disabled]="!isActive()"
          (click)="submitQuote.emit()">
          {{ 'global.tendersForm' | translate }}
        </pwj-button>
      } @else {
        <pwj-button
          variant="primary"
          size="large"
          icon="chevron-right"
          [rotateIconInRtl]="true"
          [iconReversePosition]="true"
          type="button"
          (click)="openLoginDialog()">
          {{ 'global.tendersForm' | translate }}
        </pwj-button>
      }
    </div>

    <p class="tender-submit-quote__escrow">
      <i class="iconsax tender-submit-quote__escrow-icon" icon-name="shield-tick"></i>
      {{ 'tenders.quoteProtected' | translate }}
    </p>

    <p class="tender-submit-quote__legal-links">
      {{ 'tenders.bySubmitting' | translate }}
      <a routerLink="/legal/rfq-terms" class="tender-submit-quote__legal-link" target="_blank">
        {{ 'tenders.rfqTermsLink' | translate }}</a>
      {{ 'global.and' | translate }}
      <a routerLink="/legal/payment-terms" class="tender-submit-quote__legal-link" target="_blank">
        {{ 'tenders.paymentTermsLink' | translate }}</a>.
    </p>
  </div>
</div>
